import { format, parse } from "date-fns";
import { formatInTimeZone, utcToZonedTime } from "date-fns-tz";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function formatDate(datetime, pattern) {
  return format(datetime, pattern);
}

export function convertToUTC(localdatetime, format = "yyyy/MM/dd HH:mm:ss") {
  if (typeof localdatetime == "string") {
    const dateString = localdatetime.replace(/\//g, "-").replace(/\s/, "T");
    return formatInTimeZone(dateString, "UTC", format);
  } else {
    const dateString = formatDate(localdatetime, "yyyy-MM-dd'T'HH:mm:ss");
    return formatInTimeZone(dateString, "UTC", format);
  }
}

export function convertToLocal(utcdatetime) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return utcToZonedTime(utcdatetime, timezone);
}

export function getThisWeek(date) {
  const today = date || new Date(); // Use provided date or current date
  const dayOfWeek = today.getDay();
  const start = new Date(today);
  start.setDate(today.getDate() - dayOfWeek); // Start of the week (Sunday)
  const end = new Date(start);
  end.setDate(start.getDate() + 6); // End of the week (Saturday)
  const dateArr = [];

  for (let i = new Date(start); i <= end; i.setDate(i.getDate() + 1)) {
    dateArr.push(new Date(i));
  }

  return { start, end, dateArr };
}

export function parseWPattern(string, pattern) {
  const parsedDate = parse(string, "yyyy/MM/dd", new Date());

  if (!isNaN(parsedDate.getTime())) {
    return format(parsedDate, pattern);
  } else {
    return string;
  }
}

export function getMonthName(number) {
  const index = parseInt(number, 10) - 1;
  return months[index];
}

export function formatDateString(date, pattern = "MMM dd, yyyy, h:mm a") {
  try {
    return format(new Date(date), pattern);
  } catch (error) {
    return date;
  }
}

export function formatFilterDates(date) {
  let newDate = parse(date, "yyyy/MM/dd HH:mm:ss", new Date());
  let utcDate = new Date(
    Date.UTC(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      newDate.getHours(),
      newDate.getMinutes(),
      newDate.getSeconds()
    )
  );
  let currentTzDate = convertToLocal(utcDate);
  return format(currentTzDate, "dd/MM/yyyy");
}
